import type { WorkflowExecutionNextAction } from './workflowExecutions.api';

// `next_action.status` value meaning the immediate first activity has NOT yet run
// for this application. BE derives `status` from the `AtsApplicationStageAction`
// record for (application, stage_action) — the exact record the `already_created`
// check keys off — so ANY other value (`started`/`completed`/`skipped`/`aborted`/
// `failed`), or a value at all, means the record already exists (a prior stage
// visit, or a manual action) and the automation would `already_created`-skip it.
// Only `pending` (or an absent status) means "still to run".
const FIRST_STEP_NOT_RUN_STATUS = 'pending';

// True when the automation's immediate first step (position 1) already ran for
// this candidate, so a move must NOT enqueue it into the underway popup.
//
// `position === 1` scopes this to the immediate first step (the only step the
// undo popup owns); `status` is the actual re-entry signal — `position` alone is
// always 1 on a freshly-dispatched execution and can't distinguish re-entry.
// Treated as "already ran" whenever a non-`pending` status is present, so any
// existing stage-action state (in-flight, done, or terminal) suppresses it.
export const firstStepAlreadyRan = (
  nextAction: WorkflowExecutionNextAction | undefined | null
): boolean =>
  !!nextAction &&
  nextAction.position === 1 &&
  !!nextAction.status &&
  nextAction.status !== FIRST_STEP_NOT_RUN_STATUS;
